import React, { useEffect, useRef, useContext } from 'react'
import SourceSelector from '../Session/CallBar/SourceSelector.component'
import TextField from '@mui/material/TextField'
import { BrandedButton } from '../Shared/BrandedButton/BrandedButton.component'
import { NotificationContext } from '../../context/Shared/Notification.context'
import Cookies from 'universal-cookie'
import { IoMdRefresh } from 'react-icons/io'
import { getDeviceFriendlyName } from '../../utils/functions'

export const VideoTest = () => {
  const [isVideoSettingsOpen, setIsVideoSettingsOpen] = React.useState(false)
  const [cameraSelected, setCameraSelected] = React.useState('')
  const [foundWebcams, setFoundWebcams] = React.useState({})
  const [ipAddress, setIpAddress] = React.useState('')
  const videoRef = useRef(null)
  const { setSnackBarMessage } = useContext(NotificationContext)

  const toggleWebcam = (e) => {
    setCameraSelected(e.target.value)
  }

  async function getDevices () {
    const foundWebcams = {}
    const cookies = new Cookies()

    await navigator.mediaDevices
      ?.getUserMedia({ video: true })
      .catch((error) => {
        // Error getting user media
      })

    const devices = await navigator.mediaDevices?.enumerateDevices()

    // Get disabled video devices from cookies
    const disabledVideoDevicesRaw = cookies.get('disabledVideoDevices')
    let disabledVideoDevices = []
    if (disabledVideoDevicesRaw) {
      try {
        disabledVideoDevices =
          typeof disabledVideoDevicesRaw === 'string'
            ? JSON.parse(disabledVideoDevicesRaw)
            : disabledVideoDevicesRaw
      } catch (error) {
        disabledVideoDevices = []
      }
    }

    const seenGroupIds = new Set()
    for (let i = 0; i < devices.length; i++) {
      const device = devices[i]
      if (device.deviceId === 'default' || device.deviceId === 'communications') continue
      if (device.kind === 'videoinput') {
        if (device.groupId && seenGroupIds.has(device.groupId)) continue
        if (device.groupId) seenGroupIds.add(device.groupId)
        // Skip disabled devices
        if (disabledVideoDevices.includes(device.deviceId)) {
          continue
        }
        const originalName = device.label || 'camera ' + (i + 1)
        foundWebcams[device.deviceId] = getDeviceFriendlyName(device.deviceId, originalName, cookies)
      }
    }

    setFoundWebcams(foundWebcams)
    if (Object.keys(foundWebcams).length > 0) {
      setCameraSelected(Object.keys(foundWebcams)[0])
    } else {
      setCameraSelected('')
    }
  }

  useEffect(() => {
    getDevices()
  }, [])

  useEffect(() => {
    let stream
    async function setupCamera () {
      if (cameraSelected !== '' && videoRef.current) {
        const constraints = { deviceId: { exact: cameraSelected } }
        stream = await navigator.mediaDevices.getUserMedia({
          video: constraints
        })
        if (videoRef.current) {
          videoRef.current.srcObject = stream
        }
        const cookies = new Cookies()
        const cookieIp = cookies.get(cameraSelected)
        if (cookieIp) {
          setIpAddress(cookieIp)
        } else {
          setIpAddress('')
        }
      }
    }
    setupCamera()
    return () => {
      if (stream) {
        stream.getTracks().forEach(function (track) {
          track.stop()
        })
      }
    }
  }, [cameraSelected])

  useEffect(() => {}, [cameraSelected])

  const onSaveIPAddress = () => {
    const cookies = new Cookies()
    cookies.set(cameraSelected, ipAddress, {
      maxAge: 1000 * 60 * 60 * 24 * 365 // 365 days
    })
    setSnackBarMessage('Saved', 'success')
  }

  return (
    <div>
      <video
        style={{ maxHeight: '100%', maxWidth: '100%' }}
        ref={videoRef}
        autoPlay
      ></video>
      <SourceSelector
        isOpen={isVideoSettingsOpen}
        setShowSources={setIsVideoSettingsOpen}
        sourceSelected={cameraSelected}
        toggleSource={toggleWebcam}
        foundSources={foundWebcams}
      />
      <div style={{ marginTop: 10, display: 'flex' }}>
        <TextField
          id="outlined-basic"
          label="IP Address"
          variant="outlined"
          value={ipAddress}
          onChange={(e) => setIpAddress(e.target.value)}
        />
        <div style={{ marginLeft: 10 }}>
          <BrandedButton onClick={onSaveIPAddress} buttonLabel={'Save'} />
        </div>
      </div>
      <div style={{ marginTop: 10 }}>
        <BrandedButton
          onClick={getDevices}
          buttonLabel="Refresh Devices"
          startIcon={<IoMdRefresh />}
        />
      </div>
    </div>
  )
}
